import React from "react";
import styled, { createGlobalStyle } from "styled-components";


// COMPONENTS
import AuthNavbar from "../components/AuthenticationLogin/AuthNavbar";
// CSS STYLES
import styles from '../styles/layouts/AuthLayout.module.css'

const GlobalStyle = createGlobalStyle`
    html,
    body,
    #root {
        height: 100%;
    }
    body {
        background: ${(props) => props.theme.palette.background.default};
    }
`;


// OLD LAYOUT STYLES
////////////////////////////
// const Root = styled.div`
//   max-width: 520px;
//   margin: 0 auto;
//   justify-content: center;
//   align-items: center;
//   display: flex;
//   min-height: 100%;
// `;


// const Root = styled.div`

//     width: 100vw;
//     max-width: 1400px;
//     margin: 0 auto;
//     justify-content: center;
//     align-items: center;
//     display: flex;
//     flex-direction: column;
//     min-height: 100%;
// `;



const Auth = ({ children }) => {

    const pathname = window?.location?.pathname


    return (
        // <Root>
        <div className={styles.authLayout_main_root_wrapper}>
            {/* <CssBaseline />
            <GlobalStyle /> */}
            {pathname && (pathname !== '/' && pathname !== '/auth/reset-password') ? (
                <AuthNavbar />
            ) : (null)}
            {children}
        </div>
        // </Root>
    );
};

export default Auth;
